module.exports = __webpack_public_path__ + "img/cs_qr.d06919e2.png";